export const POS_COLORS: Record<string, string> = {
  QB: "#e8538a",
  RB: "#2ca579",
  WR: "#4a90e2",
  TE: "#c47a2b",
  K: "#8888aa",
  PK: "#8888aa",
  DEF: "#6b6b6b",
};
